<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        カードリーダー管理 - 編集
        <div class="headerBtn" @click="screenTransition(curdReaderslistPath);" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの更新中に問題が発生しました。
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              カードリーダー登録情報
            </div>
            <div class="row">
              <p class="inputTitle editable">現場名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.siteName" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">CCUS 現場ID</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.ccusSiteId" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">入退場モード</p>
              <validation-provider name="入退場モード" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <div class="selectdiv">
                    <select  v-model="selectedMode">
                      <option value="" selected>入退場モードを選択</option>
                      <option v-for="mode in optionMode"
                      v-bind:value="mode.id">
                      {{ mode.name }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="buttonGroup">
            <button type="button" class="btn" @click="confirm"
              v-bind:class="{ disabled: ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'カードリーダー編集',
  name: 'CurdReaderAdd',

  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
  },

  data() {
    return {
      curdReaderslistPath: '/cardReader', // カードリーダー一覧パス
      // 更新用モデル
      detail: {
        id: '',
        deviceId: '',
        companyId: '未登録',
        companyName: '未登録',
        ccusSiteId: '',
        siteName: '未登録',
        modeId: '',
        modeName: '',
      },
      // プレースホルダー用元値
      before: {
        id: '',
        deviceId: '',
        companyId: '',
        companyName: '',
        ccusSiteId: '',
        siteName: '',
        modeId: '',
        modeName: '',
      },
      selectedMode: '', // 選択した入退場モード
      optionMode: [], // 選択用入退場モード配列
      // ローディング
      getLodingFlg: true, // データ取得時ローディング用フラグ
      getErrorFlg: false, // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false, // データ登録時エラーフラグ
      errorMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      // 入退場モード一覧取得API呼出
      this.optionMode = await this.callGetModeCategories();
      // カードリーダー一意情報取得API呼出
      this.detail = await this.callGetCardReader();
      // 入退場モードを現在の設定値で表示する
      this.selectedMode = this.detail.modeId;
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 入退場モード一覧取得API呼出
    async callGetModeCategories() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getModeCategories();
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // カードリーダー一意情報取得API呼出
    async callGetCardReader() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getCardReader(this.id);
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 変更ボタン押下時処理
    async confirm() {
      try {
        // エラーフラグ初期化
        this.postErrorFlg = false;
        // ローディング表示
        this.postLodingFlg = true;
        // カードリーダー更新API呼出
        const body = {
          id: this.id,
          deviceId: this.detail.deviceId,
          companyId: this.detail.companyId,
          ccusSiteId: this.detail.ccusSiteId,
          modeId: this.selectedMode,
        };
        const restResourceService = new ApiClient();
        await restResourceService.putCardReader(body);
        // カードリーダー一覧画面に戻る
        this.screenTransition(this.curdReaderslistPath);
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
